var map = {
	"./Picture1.png": 5754,
	"./Picture10.png": 6352,
	"./Picture11.png": 3257,
	"./Picture2.png": 4737,
	"./Picture3.png": 5672,
	"./Picture4.png": 5287,
	"./Picture5.png": 1646,
	"./Picture6.png": 4069,
	"./Picture7.png": 6556,
	"./Picture8.png": 6859,
	"./Picture9.png": 3202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8841;